import React, {useState, useEffect, useRef} from 'react'
import { useParams, useLocation } from "react-router-dom";
import Header from './Header';
import SchedulePage from './SchedulePage';
import EntryListPage from './EntryListPage';
import BroadcastEditPage from './BroadcastEditPage';
import DetailsPage from './DetailsPage';
import SearchPage from './SearchPage';
import ViewPage from './ViewPage';
import MemoDetailsPage from './MemoDetailsPage';
import MemoSearchPage from './MemoSearchPage';
import MemoViewPage from './MemoViewPage';
import AdminPage from './AdminPage';
import CssBaseline from '@mui/material/CssBaseline';
import { authURL, apiURL } from './App';
import { authJson, authFetch } from './apiClient';

// ユーザ情報
export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_superuser?: boolean; // required=Falseなのでオプショナルに
}

// メインコンポーネント
const Main = (props: { mode: string }) => {
  const [user, setUser] = useState<User | null>(null);
  const lastTrackedPath = useRef<string>(""); // 前回のパスを記憶する（画面には影響しない）
  const mode = props.mode;
  const params = useParams();
  const location = useLocation();

  // ユーザ情報取得
  const fetchUser = async () => {
    try {
      // API呼び出し
      const data = await authJson(`${authURL}/users/me/`);
      // ユーザ情報設定
      setUser(data);
    }
    catch (e) {
      // 取得エラー
      console.log(e);
      // ユーザ情報初期化
      setUser(null);
    }
  }

  // コンポーネントのマウント時
  useEffect(() => {
    console.log("User Authentication");
    // ユーザ情報取得
    fetchUser();
  },[mode]);

  // トラッキング（閲覧ページ）
  useEffect(() => {
    // パスとハッシュを合体させたフルパスを作る
    const fullPath = location.pathname + location.hash;
    // ユーザー未取得、または前回と同じフルパスなら終了
    if (!user || fullPath === lastTrackedPath.current) return;
    // 今回のフルパスを「前回の記録」として保存
    lastTrackedPath.current = fullPath;

    // ページアクセス情報を保存
    const trackPageView = async () => {
      const tracking_data = {
        userId: user.id,
        action: 'page_view',
        path: fullPath,
        mode: mode, 
        payload: params
      };
      try {
        // トラッキングログ送信
        const res = await authFetch(`${apiURL}/track`, { 
          method: 'POST', 
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(tracking_data) });
      } catch (err) {
        console.error("Page View Tracking failed:", err);
      }
    };
    trackPageView();

  }, [location.pathname, location.hash, user]);

  // 取得エラー時は何も描画しない（null返却）
  if (!user) return null;

  // レンダリング
  return (
    <div className="Main">
      <CssBaseline />
      <Header user={user}/>
      { mode === "Home" ? <SchedulePage user={user}/>
      : mode === "Entry" ? <EntryListPage user={user}/>
      : mode === "Broadcast" ? <BroadcastEditPage user={user}/>
      : mode === "Search" ? <SearchPage user={user}/>
      : mode === "NewDetails" ? <DetailsPage mode="New" user={user} id={params.id}/>
      : mode === "EditDetails" ? <DetailsPage mode="Edit" user={user} id={params.id}/>
      : mode === "Map" ? <ViewPage selectTab={1} user={user}/>
      : mode === "Calender" ? <ViewPage selectTab={2} user={user}/>
      : mode === "MemoSearch" ? <MemoSearchPage user={user}/>
      : mode === "MemoNew" ? <MemoDetailsPage mode="New" user={user}/>
      : mode === "MemoEdit" ? <MemoDetailsPage mode="Edit" user={user} id={params.id}/>
      : mode === "MemoMap" ? <MemoViewPage selectTab={1} user={user}/>
      : mode === "Admin" ? <AdminPage user={user}/>
      : ""
      }
    </div>
  );
};

export default Main;